<div *ngIf="!isSideBarOpend || width > 1024" class="row py-2 mx-0 company-header-bar w-100">
  <div
    class="company-header col-12 d-flex row-gap-2 column-gap-3 column-gap-xl-1 column-gap-xxl-3 flex-wrap flex-lg-nowrap order-last order-xl-first
    {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS? 'col-xl-8 my-2 my-xl-0 align-items-center':'col-xl-6' }}">
    <!-- <div
      *ngIf="isVisible"
      class="select-wrapper col-1 d-flex align-items-end position-relative">
      <select
        #mySelect
        class="w-100 p-l-l-15"
        [(ngModel)]="paginationBaseModel.stage"
        (change)="getCompanyDataByStageValue()"
        (click)="active = !active"
        [disabled]="currentTab === enumTabNames.REQUIREMENTS">
        <option
          value="All">
          All
        </option>
        <option
          *ngFor="let item of dropdownData"
          [selected]="item.name == 'All'"
          [value]="item.id"  [hidden]="item.name == 'Vendor'">
          {{ item.name }}
        </option>
      </select>
      <app-svg-icon
        class="active"
        [src]="'./assets/SVGIcons/arrow-down-icon.svg'"
        [ngClass]="{ 'arrow-up': active }">
      </app-svg-icon>
    </div> -->

    <!-- **********************Manufacturer List****************************** -->



    <!-- **********************Manufacturer List****************************** -->
    <!-- **********************Vendor Parts Library****************************** -->
    <!-- <ng-container *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 ps-0 ps-md-2">
        <ng-container *ngIf="route == routerPath.OEM_EXCESS ; else otherCondition">
          <app-common-dropdown [dropdown]="true" [label]="'Customer:'" [id]="'Customer'"
            [data]="getAllPartDropdown?.customerCompanyNameList" [selectValue]="oemPaginationModel?.companyId"
            (selectValueEmit)="oemPaginationModel.companyId = $event;onSelectId($event)">
          </app-common-dropdown>
        </ng-container>
        <ng-template #otherCondition>
          <app-common-dropdown [dropdown]="true" [label]="'Vendor:'" [id]="'Vendor'"
            [data]="getAllPartDropdown?.vendorNameList" [selectValue]="vplPaginationModel?.vendorId"
            (selectValueEmit)="vplPaginationModel.vendorId= $event;onSelectId($event)">
          </app-common-dropdown>
        </ng-template>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 ps-0 ps-md-3">
        <app-common-dropdown [dropdown]="true" [label]="'Manufacturer:'" [id]="'Manufacturer'"
          [data]="getAllPartDropdown?.masterManufacturerWithChildrenList"
          [selectValue]="route == routerPath.OEM_EXCESS? oemPaginationModel?.mfrId: vplPaginationModel?.mfrId"
          (selectValueEmit)="route == routerPath.OEM_EXCESS? oemPaginationModel.mfrId = $event : vplPaginationModel.mfrId = $event;onSelectId($event)">
        </app-common-dropdown>
      </div>

    </ng-container> -->
    <!-- **********************Vendor Parts Library****************************** -->

    <div class="d-flex">
      <!-- <app-button
      *ngIf="
        currentTab != this.enumTabNames.COMPANY_RECYCLEBIN &&
        currentTab != this.enumTabNames.CONTACT_RECYCLEBIN &&
        currentTab != this.enumTabNames.ARCHIVEDCOMPANIES && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)
      "
      class="mx-md-3 mx-xl-1 mx-xxl-3"
      imgUrl="/assets/SVGIcons/Plus.svg"
      [buttonLable]="enumButtonName.FILTERS"
      [buttonClass]="'border-theme'"
      [inputReadonly]="isButtonDisabled"
      (click)="isLoading === false && currentTab !== enumTabNames.REQUIREMENTS  ? OpenFilterModal() : 0"
    ></app-button> -->
      <!-- <div
      class="d-flex align-items-center px-3 clearFilters"
      (click)="clearAllFilter()"
      *ngIf="selectFilterOptionlist.length > 0">
     <app-svg-icon
        [src]="'./assets/SVGIcons/Clearicon.svg'"
        class="m-r-5">
      </app-svg-icon> -->
        <app-svg
        iconType="Clear"
        class="m-r-5 ">
      </app-svg>
      <span class="text-nowrap clear-color font-13 clearFilter pb-1" type="button">
        Clear Filters
      </span>
    <!-- </div>  -->
    </div>
  </div>
  <!-- <div *ngIf="currentTab == this.enumTabNames.ARCHIVEDCOMPANIES"
    class="company-header button-bar d-flex col-xl-6 col-md-12 col-lg-12 justify-content-end order-xl-2 order-lg-1 order-md-1">
    <app-button class="mx-1" imgUrl="" [buttonLable]="enumButtonName.UNARCHIVE"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '"
      (click)="Unarchive()">
    </app-button>

  </div> -->



  <div *ngIf="currentTab != this.enumTabNames.COMPANY_RECYCLEBIN && currentTab != this.enumTabNames.CONTACT_RECYCLEBIN 
      && currentTab != this.enumTabNames.ARCHIVEDCOMPANIES"
    [ngClass]="{'mb-1 mb-lg-0':currentTab == enumTabNames.PARTLIST}"
    class="company-header col-12 p-0 d-flex  flex-wrap justify-content-md-end
      {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)? 'col-xl-4 row-gap-2':'col-xl-6 gap-2 flex-lg-nowrap mb-3 mb-xl-0' }}">
    <!-- *ngIf="currentTab == 'Contacts' && add_Contact_Button" -->
    <!-- <ng-container *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS">
      <app-button class="mx-1" *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY" [buttonLable]="'VPL Update'"
        [buttonClass]="'border-theme'" (click)="openRequestvendorpopup()">
      </app-button>
      <app-button class="mx-1" [buttonLable]="enumButtonName.DELETE" [inputReadonly]="selectedData?.length == 0"
        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
        (click)="vplDeleteModal()">
      </app-button>
      <app-parts-button [name]="'Request'" [optionList]="route == routerPath.OEM_EXCESS ? RequestList: vplRequestList"
        [disabled]="selectedData?.length == 1?false:true"
        [innerBtnClass]="selectedData?.length == 1?'':'border-grey cursor-notAllowed'"
        (buttonOutputEvent)="onRequestClick($event)">
      </app-parts-button>
      <app-button class="mx-1" [buttonLable]="'Import'"
        (click)="route == routerPath.VENDOR_PARTS_LIBRARY ? seletedItem({index: 3}, true):seletedItem({index: 2}, true)">
      </app-button>
      <app-parts-button [name]="'New'" [optionList]="route == routerPath.OEM_EXCESS ? OemNewList : VplNewList"
        (buttonOutputEvent)="buttonNewOutputEvent($event)">
      </app-parts-button>
      <app-parts-button [name]="'Line Status'"
        [optionList]="route == routerPath.OEM_EXCESS ?  LineOEMExcessList : LineStatusList"
        [disabled]="selectedData?.length == 0 ? true:false"
        [innerBtnClass]="selectedData?.length == 0 ? 'border-grey cursor-notAllowed':''"
        (buttonOutputEvent)="buttonLineStatusEvent($event)">
      </app-parts-button>
    </ng-container> -->
    <!-- <app-button *ngIf="currentTab == this.enumTabNames.CONTACTS" imgUrl="" [buttonLable]="enumButtonName.ADDCONTACT"
      (click)="openAddContactModal()">
    </app-button>

    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS && route !== routerPath.OEM_EXCESS && currentTab != this.enumTabNames.CONTACTS && currentTab != this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" [buttonLable]="buttonName" (click)="currentTab === enumTabNames.REQUIREMENTS ? openAddRequiremnt(undefined) 
      : (currentTab !== enumTabNames.VENDOR_CONTACT ? openAddEditCompanyModal() : openAddContactModal())">
    </app-button>
    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS && currentTab !== this.enumTabNames.REQUIREMENTS && currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" [buttonLable]="enumButtonName.ADDTASK"
      (click)="selectedData?.length != 0 ? open_AddTaskComponent() : ''" [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>

    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS && currentTab !== this.enumTabNames.CONTACTS && currentTab !== this.enumTabNames.VENDOR_CONTACT  && currentTab !== this.enumTabNames.REQUIREMENTS &&  currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" [buttonLable]="enumButtonName.ASSIGN" (click)="openAssignModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>

    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS && currentTab !== this.enumTabNames.REQUIREMENTS &&  currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" [buttonLable]="enumButtonName.DELETE" (click)="openDelteModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
    </app-button>

    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS &&
      !isVisible &&
      currentTab !== this.enumTabNames.REQUIREMENTS &&
      currentTab !== this.enumTabNames.CONTACTS &&
      currentTab !== this.enumTabNames.VENDOR_LIST &&
      currentTab !== this.enumTabNames.VENDOR_CONTACT &&  currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" buttonLable="Archive" (click)="selectedDataArchive()" [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>

    <app-button *ngIf=" currentTab == this.enumTabNames.COMPANIES" imgUrl="" buttonLable="Archive"
      (click)="selectedDataArchive()" [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button> -->

    <!-- *******Mailing button add*************** -->
    <!-- <app-button
      *ngIf="currentTab == this.enumTabNames.COMPANIES || currentTab == this.enumTabNames.LEADS || currentTab == this.enumTabNames.PROSPECTS || currentTab == this.enumTabNames.CUSTOMERS"
      imgUrl="" [buttonLable]="enumButtonName.ADDMAILINGLIST" (click)="openMailingListModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button> -->
    <!-- *******Mailing button add*************** -->


    <!-- *ngIf="delete_Button" -->
    <!-- <app-button 
    *ngIf="currentTab !== this.enumTabNames.REQUIREMENTS"
      class="mx-1"
      imgUrl=""
      [buttonLable]="enumButtonName.DELETE"
      (click)="open_DeleteModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
    </app-button> -->

    <!-- *ngIf="add_Task_Button" -->
    <!-- <app-button
    *ngIf="currentTab !== this.enumTabNames.REQUIREMENTS"
      class="mx-1"
      imgUrl=""
      [buttonLable]="enumButtonName.ADDTASK"
      (click)="selectedData?.length != 0 ? open_AddTaskComponent() : ''"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button> -->
    <!-- *ngIf="currentTab == 'Contacts' && send_Email_Button" -->
    <!-- <app-button *ngIf="currentTab == this.enumTabNames.CONTACTS || currentTab == this.enumTabNames.VENDOR_CONTACT"
      imgUrl="" [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '"
      [buttonLable]="enumButtonName.SENDEMAIL">
    </app-button> -->
    <!-- !isVisible && -->

    <!-- <app-button
      *ngIf="
        !isVisible &&
        currentTab !== this.enumTabNames.CONTACTS &&
        currentTab !== this.enumTabNames.VENDOR_LIST &&
        currentTab !== this.enumTabNames.VENDOR_CONTACT"
      class="mx-1"
      imgUrl=""
      buttonLable="Archive"
      (click)="selectedDataArchive()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>
    <app-button
    *ngIf=" currentTab == this.enumTabNames.COMPANIES"
    class="mx-1"
    imgUrl=""
    buttonLable="Archive"
    (click)="selectedDataArchive()"
    [inputReadonly]="selectedData?.length == 0"
    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
  </app-button> -->

    <!-- <app-button *ngIf="currentTab == this.enumTabNames.REQUIREMENTS" imgUrl="" [buttonLable]="enumButtonName.ADDTOQUOTE"
      [inputReadonly]="selectedRequirementData?.length == 0"
      [buttonClass]="selectedRequirementData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>
    <app-button *ngIf="currentTab == this.enumTabNames.REQUIREMENTS" imgUrl=""
      [buttonLable]="enumButtonName.SENDTOSOURCING" [inputReadonly]="selectedRequirementData?.length == 0"
      [buttonClass]="selectedRequirementData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button> -->
    <!-- <span class="download-icon onhover-dropdown onhover-dropdown b-r-8 mx-1"
      *ngIf="currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)">
      <app-button [button_2]="true" [buttonClass]="'button button-primary'"
        [buttonImageUrl]="'./assets/SVGIcons/downloadicon.svg'">
      </app-button>
      <ul class="onhover-show-div">
        <li (click)="downloadPDF('pdf')" class="pb-1 f-11  text-gray text-nowrap">
          Export as PDF
        </li>
        <li (click)="downLoadExcel()" class="f-11  text-gray text-nowrap">
          Export as XLS
        </li>
      </ul>
    </span> -->
    <!-- *ngIf="currentTab !== 'Contacts' && import_Companies_Button" -->
    <!-- <span *ngIf="currentTab == this.enumTabNames.REQUIREMENTS" class="onhover-dropdown onhover-dropdown b-r-8">
      <app-button [button_2]="true" [buttonClass]="'button button-primary'" [buttonLable]="enumButtonName.ADDOFFER">
      </app-button>
      <ul class="onhover-show-div addoffer">
        <li (click)="addOfferForm('offerForm')" class="pb-1 f-11 text-light-gray text-nowrap">
          Offer Form
        </li>
        <li (click)="addOfferForm('importForm')" class="f-11 text-light-gray text-nowrap">
          Import Offer
        </li>
      </ul>
    </span> -->
<!-- 
    <app-button
      *ngIf="route !== routerPath.VENDOR_PARTS_LIBRARY && route !== routerPath.OEM_EXCESS && currentTab !== this.enumTabNames.CONTACTS && currentTab != this.enumTabNames.VENDOR_CONTACT  && currentTab !== this.enumTabNames.REQUIREMENTS && currentTab !== this.enumTabNames.PARTLIST && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      imgUrl="" [buttonLable]="buttonImport" buttonClass="'border-theme'"
      (click)="navigateToImportCompnaies(buttonImport)">
    </app-button> -->
    <!-- *****************TASK LIST BUTTONS******************************* -->
    <!-- <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST" class="mx-1" imgUrl="" [buttonLable]="buttonName"
      [inputReadonly]="selectedData?.length > 0"
      [buttonClass]="selectedData?.length == 0 ? 'border-theme': 'border-grey cursor-notAllowed' "
      (click)="selectedData?.length > 0?'':openAddPartPopup('Add Part')">
    </app-button>
    <div *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      appClickOutside (clickOutside)="closeList()" class="d-flex position-relative">
      <app-button class="mx-1 {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-xl-flex d-md-none':''}}" imgUrl=""
        [buttonLable]="buttonImport" buttonClass="'border-theme'" (click)="showlist = !showlist">
      </app-button>
      <div class="list-wrap" style="width: 100px;" *ngIf="showlist">
        <ol class="add-list-item" *ngFor="let listitem of addiconList; let i = index;let f=first">
          <li>
            <span (click)="seletedItem(i);" [ngClass]="{ activeName: listitem.selected}">{{ listitem.name }}</span>
          </li>
        </ol>
      </div>

    </div>
    <app-button *ngIf="route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      class="mx-1 {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-xl-flex d-md-none':''}}" imgUrl=""
      [buttonLable]="buttonName" (click)="openAddPartPopup('Edit Part')">
    </app-button>

    <div *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      appClickOutside (clickOutside)="closeNewList()" class="d-flex position-relative">
      <app-button class="mx-1 {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-xl-flex d-md-none':''}}" imgUrl=""
        [buttonLable]="enumButtonName.NEW"
        [inputReadonly]="selectedData?.length == 0 && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)" [buttonClass]="selectedData?.length == 1? 'border-theme'
    : route.includes(routerPath.PARTLISTINFO_ROUTEPATH)? '': 'border-grey cursor-notAllowed' "
        (click)="(selectedData?.length == 1 || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ?showNewlist = !showNewlist:''">
      </app-button>
      <div class="list-wrap" style="width: 120px;" *ngIf="showNewlist">
        <ol class="add-list-item" *ngFor="let listitem of addNewList; let i = index;let f=first">
          <li><span (click)="seletedNewItem(i);">{{ listitem.name }}</span></li>
        </ol>
      </div>

    </div>
    <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
      class="mx-1 {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-xl-flex d-md-none':''}}" imgUrl=""
      [buttonLable]="enumButtonName.CLONE"
      [inputReadonly]="selectedData?.length == 0 && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)" [buttonClass]="selectedData?.length == 1? 'border-theme'
    : route.includes(routerPath.PARTLISTINFO_ROUTEPATH)? '': 'border-grey cursor-notAllowed'"
      (click)="(selectedData?.length == 1  || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ?openCloneAddPartPopup('Add Part'):''">
    </app-button>
    <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST" class="mx-1" imgUrl=""
      [buttonLable]="enumButtonName.DELETE" (click)="openDeleteModal()" [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
    </app-button> -->
    <!-- ******************RESPONSIVE IPAD PRO********************** -->
    <!-- <div *ngIf="route.includes(routerPath.PARTLISTINFO_ROUTEPATH)" class="d-flex d-xl-none d-md-flex">
      <div appClickOutside (clickOutside)="closeMenuList()" ngbDropdown class="threeDotIcon">
        <img src="./assets/SVGIcons/threedot.svg" alt="" id="dropdownConfig" ngbDropdownToggle width="35" height="35" />

        <div ngbDropdownMenu aria-labelledby="dropdownConfig" style="color:#8B9DAA;font-weight: 600;">
          <div class="position-relative">
            <span (click)="showImportSubmenu = !showImportSubmenu " class="px-2 font-11 text-light-gray">Import</span>
            <ng-template [ngIf]="showImportSubmenu">
              <ol class="dropdown-item " *ngFor="let listitem of addiconList; let i = index;let f=first">
                <li>
                  <span (click)="seletedItem(i);" [ngClass]="{ activeName: listitem.selected}">{{ listitem.name
                    }}</span>
                </li>
              </ol>
            </ng-template>
          </div>
          <span class="px-2 font-11 text-light-gray" (click)="openAddPartPopup('Edit Part')">Edit Part</span> <br>
          <div class="position-relative">
            <span (click)="showNewSubmenu = !showNewSubmenu" class="px-2 font-11 text-light-gray">New</span>
            <ng-template [ngIf]="showNewSubmenu">
              <ol class="dropdown-item " *ngFor="let listitem of addNewList; let i = index;let f=first">
                <li><span (click)="seletedNewItem(i);">{{ listitem.name }}</span></li>
              </ol>
            </ng-template>
          </div>
          <span class="px-2 font-11 text-light-gray"
            (click)="(selectedData?.length == 1  || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ?openCloneAddPartPopup('Add Part'):''">Clone</span><br>
        </div>
      </div>
    </div> -->
    <!-- ******************RESPONSIVE IPAD PRO********************** -->


    <!-- *****************TASK LIST BUTTONS******************************* -->


    <!-- <app-svg-icon
      [src]="'./assets/SVGIcons/pin.svg'"
      class="p-l-5 d-flex  {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS? 'align-items-baseline':'align-items-center' }}"
      (click)="pinned = !pinned; openFavouriteDockPopup(pinned)"
      [ngClass]="pinned == true ? 'pinnedColor' : ''">
    </app-svg-icon> -->
    <app-svg iconType="Pin"
    class="p-l-5 d-flex  {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS? 'align-items-baseline':'align-items-center' }}"
      (click)="pinned = !pinned; openFavouriteDockPopup(pinned)"
      [ngClass]="pinned == true ? 'pinnedColor' : ''">
    </app-svg>

  </div>
  <!-- for company-recycle-Bin and contact-recycle-Bin start-->
  <!-- <div *ngIf="currentTab == this.enumTabNames.COMPANY_RECYCLEBIN || currentTab == this.enumTabNames.CONTACT_RECYCLEBIN"
    class="company-header button-bar d-flex col-xl-6 col-md-12 col-lg-12 justify-content-end order-xl-2 order-lg-1 order-md-1">
    <div class="d-flex">
      <app-button class="mx-1" imgUrl="" [inputReadonly]="selectedData?.length == 0"
        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
        (click)="restore(currentTab)" [buttonLable]="enumButtonName.RESTORE">
      </app-button>
      <app-button class="mx-1" imgUrl=""
        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
        [buttonLable]="enumButtonName.APPROVEDELETION" (click)="approveDeletion(currentTab)"></app-button>
    </div>
  </div> -->
  <!-- for company-recycle-Bin and contact-recycle-Bin end-->
</div>
<!-- When we open side bar for I Pad Pro-->
<div *ngIf="isSideBarOpend && width <= 1024"
  class="d-flex flex-column flex-lg-wrap flex-md-wrap py-2 company-header-bar w-100">
  <div class="d-flex">
    <app-search-input inputSearchPlaceholder="Search by company name…" class="w-330px px-3 d-flex align-items-end"
      [ngClass]="{ 'ps-0': !isVisible }" [inputSerachValue]="paginationBaseModel.searchText" (inputSerachValueEmit)="
        searchTextFilter((paginationBaseModel.searchText = $event))">
    </app-search-input>
    <app-button class="mx-1" imgUrl="" [buttonLable]="enumButtonName.ASSIGN" (click)="openAssignModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '"></app-button>
    <app-button class="mx-1" imgUrl="" [buttonLable]="enumButtonName.DELETE" (click)="openDelteModal()"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
    </app-button>
    <app-button class="mx-1" imgUrl="" [buttonLable]="enumButtonName.ADDTASK"
      [inputReadonly]="selectedData?.length == 0"
      [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
    </app-button>
  </div>
  <div class="company-header d-flex col-xl-6 col-md-12 col-lg-12 mt-3">
    <div *ngIf="isVisible" class="select-wrapper col-1 d-flex align-items-end position-relative">
      <select #mySelect class="w-100 p-l-15" [(ngModel)]="paginationBaseModel.stage"
        (change)="getCompanyDataByStageValue()" (click)="active = !active">
        <option *ngFor="let item of dropdownData" [selected]="item.name == 'All'" [value]="item.name">
          {{ item.name }}
        </option>
      </select>
      <!-- <app-svg-icon
        class="active"
        [src]="'./assets/SVGIcons/arrow-down-icon.svg'"
        [ngClass]="{ 'arrow-up': active }" >
      </app-svg-icon> -->
      <app-svg class="active"
        iconType="ArrowDown"
        [ngClass]="{ 'arrow-up': active }"></app-svg>
    </div>
    <app-button class="px-3" imgUrl="/assets/SVGIcons/Plus.svg" [buttonLable]="enumButtonName.FILTERS"
      [buttonClass]="'border-theme'" (click)="isLoading === false ? OpenFilterModal() : 0">
    </app-button>
    <div
      class="d-flex align-items-center px-3"
      (click)="clearAllFilter()"
      *ngIf="selectFilterOptionlist.length > 0">
      <!-- <app-svg-icon
        [src]="'./assets/SVGIcons/Clearicon.svg'"
        class="m-r-5">
      </app-svg-icon> -->
        <app-svg
        iconType="Clear"
        class="m-r-5">
      </app-svg>

      <span 
      class="text-nowrap clear-color font-13 m-t-2" 
      type="button">Clear Filters</span>
    </div>
  </div>
</div>
<!-- flex-wrap -->

<!-- <app-filter [items]="selectFilterOptionlist"></app-filter> -->